import React, { useEffect, useState } from "react";
import AspApi from "../../../../api/ApiConfig";
import {
  Button,
  Typography,
  Space,
  Card,
  Divider,
  Alert,
  Flex,
  Popover,
  Spin,
} from "antd";
const { Text, Title, Paragraph } = Typography;

import {
  CaretDownOutlined,
  CheckCircleFilled,
  CloseOutlined,
  InfoCircleFilled,
  LoadingOutlined,
  RetweetOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchFacebookConnection,
  fetchFacebookPagesList,
  fetchFacebookAdAccountsList,
  postSelectedPage,
  postSelectedAdAccount,
  flushFacebookChannel,
  setFacebookChannel,
  fetchWhatsappNumbers,
  saveBusinessPhoneNumber,
} from "../../../../reduxToolkit/channelSlice";
import { ICONS } from "../../../../assets/icons";
import { DropDownListContent } from "../../components/facebook/DropDownListContent";
import { DropDownListContentSkeleton } from "../../components/facebook/DropDownListContentSkeleton";
import { WhatsappBusinessNUmberList } from "../../components/facebook/WhatsappBusinessNUmberList";
import moment from "moment";

const index = () => {
  const dispatch = useDispatch();
  const {
    facebook_channel,
    facebook_connections_loading,
    fetch_facebook_connection_error,

    facebook_ad_account_details,
    ad_accounts_list_loading,
    fetch_ac_accounts_error,

    pages_list_loading,
    facebook_page_details,
    fetch_pages_error,

    whatsappBusinessNumbersListLoading,
    saveWabaBusinessLoading,

    page_business_number,
  } = useSelector((state) => state.Channel);
  const { currentBrand } = useSelector((state) => state?.app);
  const brand_id = currentBrand?.brand_id;

  const {
    page_id,
    page_name,
    picture: page_picture,
  } = facebook_page_details || {};

  const {
    business_id,
    ad_account_id,
    name: ad_account_name,
  } = facebook_ad_account_details || {};

  const { facebook_connected, channel_id, channel_active } =
    facebook_channel || {};

  const {
    id: whatsapp_number_id,
    current_time_stamp,
    verification_status,
  } = page_business_number || {};

  const [metaAuthCode, setMetaAuthCode] = useState("");
  const [pagePopUp, setPagePopUp] = useState(false);
  const [adAccPopup, setAdAccPopup] = useState(false);
  const [whatsappNumbersPopup, setWhatsappNumbersPopup] = useState(false);
  const [fbWizardOpen, setFbWizardOpen] = useState(false);

  const launchFbReq = async () => {
    setFbWizardOpen(true);
    await FB.login(
      function (response) {
        setFbWizardOpen(false);

        if (response.authResponse) {
          const code = response.authResponse.code;
          setMetaAuthCode(code);
        } else {
          console.warn("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: 888121073352552, // page_with_ads_all_access
        response_type: "code",
        override_default_response_type: true,
      },
    );
  };

  useEffect(() => {
    dispatch(fetchFacebookConnection(brand_id));
  }, [dispatch]);

  useEffect(() => {
    const initializeChannel = async () => {
      if (metaAuthCode) {
        await createChannel(metaAuthCode);
      }
    };
    initializeChannel();
  }, [metaAuthCode]);

  async function createChannel(access_code) {
    try {
      const payload = {
        access_code,
        brand_id: brand_id,
      };
      const res = await AspApi.post(
        `/api/v1/svc/facebook/connections`,
        payload,
      );

      dispatch(flushFacebookChannel());
      dispatch(setFacebookChannel(res.data));
      return res;
    } catch (error) {
      res;
      console.log("channel creation failed", error);
    }
  }

  const handleSelectPage = (page) => {
    const payload = {
      page_id: page?.id,
      page_name: page?.name,
      brand_id: brand_id,
      access_token: page.access_token,
      picture: page?.picture?.data?.url,
    };
    dispatch(postSelectedPage(payload));
    setPagePopUp(false);
  };

  const handleSelectAdAccount = (ad_account) => {
    const payload = {
      business_id: ad_account?.business?.id,
      name: ad_account.name,
      ad_account_id: ad_account.id,
      brand_id: brand_id,
    };
    dispatch(postSelectedAdAccount(payload));
    setAdAccPopup(false);
  };

  const handleSelectBusinessNumber = (whatsapp_number_id) => {
    const payload = {
      whatsapp_number_id,
      brand_id: brand_id,
    };
    dispatch(saveBusinessPhoneNumber(payload));
    setWhatsappNumbersPopup(false);
  };

  const handlePopover = (state, setOpen, fetchData, listLoading) => {
    setOpen((open) => {
      if (!facebook_connections_loading && !fbWizardOpen) {
        return !open;
      } else {
        return false;
      }
    });
    if (state) {
      if (listLoading || fbWizardOpen) return;
      dispatch(fetchData(brand_id));
    }
  };

  const selectBusinessNumberRestricted = () => {
    if (!current_time_stamp) return true;
    if (verification_status !== "VERIFICATION_CODE_TOO_FAST") return true;

    const verified = moment.utc(current_time_stamp);
    const now = moment.utc();
    return (
      verification_status === "VERIFICATION_CODE_TOO_FAST" &&
      now.diff(verified, "hours") >= 24
    );
  };

  const hasPassed24Hours = selectBusinessNumberRestricted();

  return (
    <Card className="mx-auto p-6 bg-white rounded-lg shadow-md w-full overflow-scroll h-full">
      <Space direction="vertical" className="w-full">
        <Space align="center">
          <Flex justify="center" align="center" gap="small">
            <img src={ICONS.crmFaceBook} alt="" className="size-10" />
            <Title level={4} className="m-0">
              Facebook Business Platform (API)
            </Title>
          </Flex>
        </Space>

        <Paragraph type="secondary" className="max-w-[75%]">
          Link up the Facebook Business Platform (API) through Facebook to make
          chatting with customers easier, boost sales, and improve support!
        </Paragraph>
        <Paragraph type="secondary" className="max-w-[75%]">
          Connect the Facebook Business Platform (API) via Facebook to chat with
          your customers more easily, increase sales, and enhance support!
        </Paragraph>
        <Space size="middle">
          <Button
            type="primary"
            loading={facebook_connections_loading || fbWizardOpen}
            disabled={facebook_connections_loading || fbWizardOpen}
            className="bg-blue-600"
            onClick={launchFbReq}
          >
            {facebook_connected && channel_active
              ? "Reconnect"
              : "Continue with Facebook"}
          </Button>

          <Button type="link">Watch Demo →</Button>
        </Space>
      </Space>

      <Divider />

      <Space className="w-[90%]" direction="vertical">
        <Title level={5}>What you will need:</Title>

        {/*  Facebook pages Section */}
        <Flex align="center" justify="space-between">
          <Space direction="vertical" className="max-w-[50%]">
            <Text strong>Choose your Facebook page</Text>
            <Text type="secondary" className="text-xs">
              Select Facebook page which will be used to ad
            </Text>
          </Space>
          <Space direction="vertical" size="small" className="w-[50%]">
            {facebook_page_details.page_id && (
              <Space>
                <Text strong className="text-gray-900">
                  Facebook page connected
                </Text>
                <CheckCircleFilled className="text-green-500 text-lg" />
              </Space>
            )}

            <Popover
              content={() => (
                <PagesDropDownList
                  selectAction={handleSelectPage}
                  handlePopoverState={setPagePopUp}
                  PopoverState={pagePopUp}
                />
              )}
              arrow={false}
              trigger={"click"}
              placement="bottom"
              open={pagePopUp}
              onOpenChange={(open) =>
                handlePopover(
                  open,
                  setPagePopUp,
                  fetchFacebookPagesList,
                  pages_list_loading,
                )
              }
            >
              <Flex
                justify="space-between"
                className="border border-gray-100 rounded-md pe-4 hover:cursor-pointer"
              >
                {facebook_connections_loading ? (
                  <div className="p-2 w-full">
                    <DropDownListContentSkeleton />
                  </div>
                ) : (
                  <>
                    {page_id ? (
                      <DropDownListContent
                        page_id={page_id}
                        page_name={page_name}
                        avatar={page_picture}
                      />
                    ) : (
                      <Space className="bg-white p-2 rounded-md">
                        <Text>Choose your Facebook Page</Text>
                      </Space>
                    )}
                    {facebook_connections_loading || fbWizardOpen ? (
                      <LoadingOutlined spin />
                    ) : (
                      <CaretDownOutlined className="text-gray-400" />
                    )}
                  </>
                )}
              </Flex>
            </Popover>
          </Space>
        </Flex>

        <Divider className="my-2" />

        {/*  Ad Account List Section */}

        <Flex align="center" justify="space-between">
          <Space direction="vertical" className="max-w-[50%]">
            <Text strong>Choose Your Ad Account</Text>
            <Text type="secondary" className="text-xs">
              Select Ad Account which will be used to ad
            </Text>
          </Space>

          <Space direction="vertical" size="small" className="w-[50%]">
            {facebook_ad_account_details.ad_account_id && (
              <Space>
                <Text strong className="text-gray-900">
                  Ad Account connected
                </Text>
                <CheckCircleFilled className="text-green-500 text-lg" />
              </Space>
            )}

            <Popover
              content={() => (
                <AdAccountsDropDownList
                  handleSelectAdAccount={handleSelectAdAccount}
                  handlePopoverState={setAdAccPopup}
                  PopoverState={adAccPopup}
                />
              )}
              arrow={false}
              trigger={"click"}
              placement="bottom"
              open={
                adAccPopup && !facebook_connections_loading && !fbWizardOpen
              }
              onOpenChange={(open) =>
                handlePopover(
                  open,
                  setAdAccPopup,
                  fetchFacebookAdAccountsList,
                  ad_accounts_list_loading,
                )
              }
            >
              <Flex
                justify="space-between"
                className="border border-gray-100 rounded-md pe-4 hover:cursor-pointer"
              >
                {facebook_connections_loading ? (
                  <div className="p-2 w-full">
                    <DropDownListContentSkeleton />
                  </div>
                ) : (
                  <>
                    {facebook_ad_account_details.ad_account_id ? (
                      <DropDownListContent
                        page_id={ad_account_id}
                        page_name={ad_account_name}
                      />
                    ) : (
                      <Space className="bg-white p-2 rounded-md">
                        <Text>Choose your Ad Account</Text>
                      </Space>
                    )}

                    {facebook_connections_loading || fbWizardOpen ? (
                      <LoadingOutlined spin />
                    ) : (
                      <CaretDownOutlined className="text-gray-400" />
                    )}
                  </>
                )}
              </Flex>
            </Popover>
          </Space>
        </Flex>

        <Divider className="my-2" />

        {/*  Phone number Section */}

        <Flex align="center" justify="space-between">
          <Space direction="vertical" className="max-w-[50%]">
            <Text strong>Link WhatsApp Number</Text>
            <Text type="secondary" className="text-xs">
              Link your WhatsApp business number with the selected Facebook page
              to receive messages directly over WhatsApp.
            </Text>
          </Space>
          <Space direction="vertical" className="w-[50%]">
            <PhoneNumberVerification
              hasPassed24Hours={hasPassed24Hours}
              retry={() => handleSelectBusinessNumber(whatsapp_number_id)}
            />
            <Popover
              content={
                <WhatsappBusinessNUmberList
                  selectBusinessNumber={handleSelectBusinessNumber}
                />
              }
              arrow={false}
              trigger={"click"}
              placement="bottom"
              open={
                whatsappNumbersPopup &&
                !facebook_connections_loading &&
                !fbWizardOpen &&
                hasPassed24Hours &&
                !saveWabaBusinessLoading
              }
              onOpenChange={(open) =>
                hasPassed24Hours &&
                !saveWabaBusinessLoading &&
                handlePopover(
                  open,
                  setWhatsappNumbersPopup,
                  fetchWhatsappNumbers,
                  whatsappBusinessNumbersListLoading,
                )
              }
            >
              <Flex
                justify="space-between"
                className="border border-gray-100 min-w-[30vw] rounded-md px-4 py-2 hover:cursor-pointer"
              >
                {facebook_connections_loading ? (
                  <DropDownListContentSkeleton />
                ) : page_business_number?.id ? (
                  <Space>
                    <Text>{page_business_number?.name}</Text>
                    <Text>
                      {page_business_number?.country_code}{" "}
                      {page_business_number?.phone_number}
                    </Text>
                  </Space>
                ) : (
                  <Text>Choose Whatsapp Number </Text>
                )}

                {saveWabaBusinessLoading || fbWizardOpen ? (
                  <LoadingOutlined spin />
                ) : (
                  <CaretDownOutlined className="text-gray-400" />
                )}
              </Flex>
            </Popover>
          </Space>
        </Flex>
      </Space>

      <Divider />

      <Title level={5}>Channel requirements:</Title>
      <Space direction="vertical" className="w-[75%]">
        <Text className="text-xs">
          <Text strong>1. A phone number:</Text> Keep your business phone number
          handy to receive OTP! It's important this number is not connected to
          any WhatsApp account.
        </Text>
        <Text className="text-xs">
          <Text strong>2. Access to a personal Facebook account:</Text> That has
          been added to the Meta Business Suite for your business with admin
          rights.
        </Text>
        <Text className="text-xs">
          <Text strong>3. A profile picture:</Text> File format: PNG or JPEG.
          Optimal dimension 640x640 pixels.
        </Text>
      </Space>

      <Alert
        message="Don't have all you need to install WhatsApp?"
        type="info"
        showIcon
        className="mt-4 w-[75%]"
        action={<Button type="link">View Guide</Button>}
      />
    </Card>
  );
};

const PhoneNumberVerification = ({ retry = () => {}, hasPassed24Hours }) => {
  const { page_business_number, facebook_connections_loading } = useSelector(
    (state) => state.Channel,
  );

  if (facebook_connections_loading) return;

  const {
    verification_status,
    verification_error_message,
    current_time_stamp,
  } = page_business_number || {};

  if (!verification_status) return;

  // const verified = moment.utc(current_time_stamp);
  // const now = moment.utc();
  // const hasPassed24Hours = now.diff(verified, "hours") >= 24;

  // when hasPassed24Hours exceeds 24 hours
  if (
    verification_status === "VERIFICATION_CODE_TOO_FAST" &&
    hasPassed24Hours
  ) {
    return (
      <Space>
        <Text strong>Retry now</Text>
        <RetweetOutlined onClick={retry} className="hover:cursor-pointer" />
      </Space>
    );
  }

  // when hasPassed24Hours is within 24 hours
  if (
    verification_status === "VERIFICATION_CODE_TOO_FAST" &&
    !hasPassed24Hours
  ) {
    return (
      <Space>
        <Text>Wait for 24 hours</Text>
        <Popover
          content={
            <Paragraph className="p-4">
              {verification_error_message || "Maximum rate reached"}
            </Paragraph>
          }
        >
          <InfoCircleFilled className="hover:cursor-pointer" />
        </Popover>
      </Space>
    );
  }

  if (verification_status === "BUSINESS_REQUEST_SEND_SUCCESS") {
    return (
      <Flex justify="space-between">
        <Space>
          <Text>Waiting for approval</Text>
          <Popover
            content={
              <Paragraph className="p-4">
                Facebook has send an request to use this business number.
              </Paragraph>
            }
          >
            <InfoCircleFilled className="hover:cursor-pointer" />
          </Popover>
        </Space>
        <RetweetOutlined onClick={retry} className="hover:cursor-pointer" />
      </Flex>
    );
  }

  if (verification_status === "VERIFIED") {
    return (
      <Space gap={"middle"}>
        <Text strong>Verified</Text>
        <CheckCircleFilled className="text-green-500 text-lg" />
      </Space>
    );
  }
};

// Pages List drop down component
const PagesDropDownList = ({
  PopoverState,
  business_name = "Business",
  selectAction = () => {},
  handlePopoverState = () => {},
}) => {
  const {
    pages_list_loading,
    pages_list,
    facebook_page_details,
    save_page_loading,
    fetch_pages_error,
    facebook_channel,
  } = useSelector((state) => state.Channel);
  const { page_id, page_name, picture: page_picture } = facebook_page_details;
  const { facebook_connected, channel_active } = facebook_channel || {};

  return facebook_connected && channel_active ? (
    <Space className="p-4 max-h-[40vh] overflow-scroll">
      {pages_list_loading ? (
        <Spin
          indicator={<LoadingOutlined spin />}
          size="large"
          className="w-[20vw]"
        />
      ) : (
        <Space
          direction="vertical"
          className="border border-gray-100 rounded-md p-4"
        >
          <Flex align="center" justify="space-between" className="min-w-[20vw]">
            <Title style={{ margin: 0 }} level={5}>
              {business_name}
            </Title>
            <Flex
              justify="center"
              align="center"
              className="p-1 rounded-full bg-gray-100 hover:cursor-pointer"
              onClick={() => handlePopoverState(false)}
            >
              <CloseOutlined className="text-gray-600 size-3" />
            </Flex>
          </Flex>

          <Flex vertical gap={"small"} className="bg-gray-50 p-2 rounded-md">
            {pages_list.map((item) => {
              return (
                <Flex
                  key={item?.id}
                  className="bg-white w-[25vw] pe-2 hover:cursor-pointer"
                  align="center"
                  justify="space-between"
                  onClick={() =>
                    !save_page_loading &&
                    page_id != item.id &&
                    selectAction(item)
                  }
                >
                  <DropDownListContent
                    page_id={item.id}
                    page_name={item.name}
                    avatar={item?.picture?.data?.url}
                  />

                  <div className="size-4 flex items-center justify-center border border-gray-400 rounded-full cursor-pointer">
                    {page_id == item.id ? (
                      <CheckCircleFilled className="text-green-500 text-lg" />
                    ) : null}
                  </div>
                </Flex>
              );
            })}
          </Flex>
        </Space>
      )}
    </Space>
  ) : (
    <Space className="p-4">
      <Text>Please connect Facebook to continue</Text>
    </Space>
  );
};

// Ad Account list component
const AdAccountsDropDownList = ({
  PopoverState,
  business_name = "Business",
  handleSelectAdAccount = () => {},
  handlePopoverState = () => {},
}) => {
  const {
    ad_accounts_list,
    facebook_ad_account_details,
    ad_accounts_list_loading,
    fetch_ac_accounts_error,
    save_ad_account_loading,
    facebook_channel,
  } = useSelector((state) => state.Channel);
  const { business_id, ad_account_id, name } = facebook_ad_account_details;
  const { facebook_connected, channel_active } = facebook_channel || {};

  return facebook_connected && channel_active ? (
    <Space className="p-4 max-h-[40vh] overflow-scroll">
      {ad_accounts_list_loading ? (
        <Spin
          indicator={<LoadingOutlined spin />}
          size="large"
          className="w-[20vw]"
        />
      ) : (
        <Space
          direction="vertical"
          className="border border-gray-100 rounded-md p-4"
        >
          <Flex align="center" justify="space-between" className="min-w-[20vw]">
            <Title style={{ margin: 0 }} level={5}>
              {business_name}
            </Title>
            <Flex
              justify="center"
              align="center"
              className="p-1 rounded-full bg-gray-100 hover:cursor-pointer"
              onClick={() => handlePopoverState(false)}
            >
              <CloseOutlined className="text-gray-600 size-3" />
            </Flex>
          </Flex>

          <Flex vertical gap={"small"} className="bg-gray-50 p-2 rounded-md">
            {ad_accounts_list.map((item) => {
              return (
                <Flex
                  key={item?.id}
                  className="bg-white w-[25vw] pe-2 hover:cursor-pointer"
                  align="center"
                  justify="space-between"
                  onClick={() =>
                    !save_ad_account_loading &&
                    ad_account_id != item.id &&
                    handleSelectAdAccount(item)
                  }
                >
                  <DropDownListContent
                    page_id={item.id}
                    page_name={item.name}
                    avatar={item?.picture?.data?.url}
                  />

                  <div className="size-4 flex items-center justify-center border border-gray-400 rounded-full cursor-pointer">
                    {ad_account_id == item.id ? (
                      <CheckCircleFilled className="text-green-500 text-lg" />
                    ) : null}
                  </div>
                </Flex>
              );
            })}
          </Flex>
        </Space>
      )}
    </Space>
  ) : (
    <Space className="p-4">
      <Text>Please connect Facebook to continue</Text>
    </Space>
  );
};

export default index;
